module.exports = __webpack_public_path__ + "static/media/bg-red-gradient.7441960a.svg";